import React from 'react';
interface LogoProps {
  className?: string;
  variant?: 'default' | 'onDark';
}
/**
 * Mortgage Depot brand logo.
 * Stylized house/roof mark + wordmark, matching mymtgdepot.com.
 */
export function Logo({
  className = 'h-10 w-auto',
  variant = 'default'
}: LogoProps) {
  const stroke = variant === 'onDark' ? '#2563EB' : '#2563EB';
  const text = variant === 'onDark' ? '#1B2B6B' : '#1B2B6B';
  return <svg viewBox="0 0 240 80" xmlns="http://www.w3.org/2000/svg" className={className} role="img" aria-label="Mortgage Depot" data-id="element-938">
      {/* House / roof mark */}
      <g fill="none" stroke={stroke} strokeWidth="4" strokeLinejoin="round" strokeLinecap="round" data-id="element-939">
        {/* Outer roof peak */}
        <path d="M8 42 L40 14 L72 42" data-id="element-940" />
        {/* Inner roof peak */}
        <path d="M22 42 L40 26 L58 42" data-id="element-941" />
        {/* Chimney */}
        <path d="M56 22 L56 14 L62 14 L62 28" data-id="element-942" />
      </g>
      {/* MORTGAGE */}
      <text x="86" y="38" fontFamily="Inter, system-ui, -apple-system, sans-serif" fontWeight="800" fontSize="22" letterSpacing="1" fill={text} data-id="element-943">
        MORTGAGE
      </text>
      {/* DEPOT with divider lines */}
      <g data-id="element-944">
        <line x1="86" y1="54" x2="118" y2="54" stroke={stroke} strokeWidth="2" data-id="element-945" />
        <text x="124" y="60" fontFamily="Inter, system-ui, -apple-system, sans-serif" fontWeight="700" fontSize="14" letterSpacing="4" fill={stroke} data-id="element-946">
          DEPOT
        </text>
        <line x1="178" y1="54" x2="210" y2="54" stroke={stroke} strokeWidth="2" data-id="element-947" />
      </g>
    </svg>;
}